var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIran(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8976 8.86955H14.3275C14.3405 9.0421 14.3479 9.21619 14.3479 9.39127C14.3479 10.5521 14.0577 11.6772 13.5519 12.4781C13.3958 12.7252 13.1336 13.074 12.7826 13.3093V8.86951H11.2174V13.3093C10.8665 13.074 10.6042 12.7252 10.4481 12.4781C9.94227 11.6772 9.65216 10.5521 9.65216 9.39127C9.65216 9.21619 9.65957 9.04205 9.67251 8.86955H8.10248C8.0924 9.04126 8.08691 9.21516 8.08691 9.39127C8.08691 12.6095 9.80573 15.1304 11.9999 15.1304C14.1942 15.1304 15.913 12.6095 15.913 9.39127C15.9131 9.21516 15.9076 9.04126 15.8976 8.86955Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95623 5.73914H6.52143V6.78263H8.08663V5.73914H9.65184V6.78263H11.217V5.73914H12.7822V6.78263H14.3474V5.73914H15.9126V6.78263H17.4779V5.73914H19.0431V6.78263H22.8089C20.868 2.76867 16.7572 0 11.9997 0C7.24223 0 3.13143 2.76867 1.19043 6.78263H4.95623V5.73914Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0432 17.2174V18.2609H17.478V17.2174H15.9128V18.2609H14.3476V17.2174H12.7824V18.2609H11.2172V17.2174H9.65198V18.2609H8.08677V17.2174H6.52143V18.2609H4.95623V17.2174H1.19043C3.13143 21.2314 7.24218 24 11.9997 24C16.7572 24 20.868 21.2314 22.809 17.2174H19.0432Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/11047edf.svg";
export { SvgIran as ReactComponent };